var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-upload-image',{attrs:{"file-list":_vm.fileList,"max-upload-image-limit":_vm.fileNumber || 5,"image-size-limit":_vm.fileSize || 100},on:{"on-change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }